import React from 'react'
import Translation from '../../Translation/cont/Translation'
import OverlayWrapper from './OverlayWrapper'

const OverlaySpinner = ({transId}) => (
    <OverlayWrapper>
        <div className="spinner"></div>
        <p className="title-large-color text"><Translation id={transId}/></p>
    </OverlayWrapper>
)

export default OverlaySpinner